import {Tab} from '@material-ui/core';
import {Tabs, Tooltip, Typography, styled} from '@mui/material';
import React, {useState} from 'react';
import {EarnedStatements} from './EarnedStatements';
import {EmployerSummary} from './EmployerSummary';
import {A360CommissionSection} from '../CommissionSection';
import {AdvancedStatements} from './AdvancedStatements';

export const A360CommissionStatements = () => {
  const [selectedStatement, setSelectedStatement] = useState(0);
  const earnedCommiHoverTxt = <Typography>Earned Commission Statements<br />
  <i><h5>Earned commissions run weekly. If you are registered for direct deposit, funds are deposited 3 days post statement date.</h5></i></Typography>;

  const handleChange = (_e: React.SyntheticEvent, newValue: number) => {
    setSelectedStatement(newValue);
  };

  return (
    <A360CommissionSection
      className="a360-commissions__commission-statements"
      title="Statement Details"
      fontSize="2.25rem"
      aria-label="statement details"
    >
      <Tabs
        value={selectedStatement}
        onChange={handleChange}
        aria-label="commissions statement tabs"
        scrollButtons="auto"
        variant="scrollable"
        allowScrollButtonsMobile
        indicatorColor="primary"
        className="a360-commissions__commission-statement_tabs"
      >
        <Tab
          className="a360-commissions__commission-statement_tab"
          label="Employer Summary"
          id="a360-commissions-statement-employer-summary"
          aria-controls=""
        />
        <CustomTooltip title={earnedCommiHoverTxt} arrow placement="right-start">
          <Tab
            className="a360-commissions__commission-statement_tab"
            label="Earned"
            id="a360-commissions-statement-earned"
            aria-controls=""
          />
        </CustomTooltip>
        <Tab
          className="a360-commissions__commission-statement_tab"
          label="Advanced"
          id="a360-commissions-statement-advanced"
          aria-controls=""
        />
      </Tabs>
      <A360CommissionStatementTab index={0} value={selectedStatement}>
        <EmployerSummary />
      </A360CommissionStatementTab>
      <A360CommissionStatementTab index={1} value={selectedStatement}>
        <EarnedStatements />
      </A360CommissionStatementTab>
      <A360CommissionStatementTab index={2} value={selectedStatement}>
        <AdvancedStatements />
      </A360CommissionStatementTab>
    </A360CommissionSection>
  );
};

const CustomTooltip = styled(Tooltip)(({ theme }) => ({
  '.MuiTooltip-arrow': {
    color: 'blue',
  },
}));

const A360CommissionStatementTab = ({
  children,
  index,
  value,
}: {
  children: React.ReactNode;
  index: number;
  value: number;
}) => {
  return (
    <div role="tabpanel" hidden={value !== index} id={`tab-panel-${index}`} aria-labelledby={`tab-${index}`}>
      {value === index && <div>{children}</div>}
    </div>
  );
};
